import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import FilmIncentiveForm from 'components/FilmIncentiveForm';
import { Icon } from 'utils/icons';

import './styles.scss';

const FilmIncentiveEditorModal = ({
  show,
  onHide,
  incentive,
  budgetId,
  tags,
  onSave,
  onDelete,
  isSaving,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    size="lg"
    className="film-incentive-editor-modal"
    dialogClassName="film-incentive-editor-dialog"
  >
    <Modal.Body>
      <div className="film-incentive-editor-modal__header">
        <div className="film-incentive-editor-modal__title">
          <Icon name="DollarSignIcon" />
          <div>
            <h2>{incentive ? 'Edit Credit' : 'Add New Credit'}</h2>
            <p>One rate and qualified-spend basis per credit line.</p>
          </div>
        </div>
        <button
          type="button"
          className="film-incentive-editor-modal__close"
          onClick={onHide}
          disabled={isSaving}
          aria-label="Close"
        >
          <Icon name="CloseIcon" />
        </button>
      </div>
      <FilmIncentiveForm
        incentive={incentive}
        budgetId={budgetId}
        tags={tags}
        onSave={onSave}
        onCancel={onHide}
        onDelete={incentive ? onDelete : null}
        isSaving={isSaving}
      />
    </Modal.Body>
  </Modal>
);

FilmIncentiveEditorModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  incentive: PropTypes.object,
  budgetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tags: PropTypes.arrayOf(PropTypes.object),
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  isSaving: PropTypes.bool,
};

FilmIncentiveEditorModal.defaultProps = {
  show: false,
  incentive: null,
  budgetId: null,
  tags: [],
  onDelete: null,
  isSaving: false,
};

export default FilmIncentiveEditorModal;
